import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "release-notes"
    }}>{`Release notes`}</h1>
    <h2 {...{
      "id": "march-28-2025"
    }}>{`March 28, 2025`}</h2>
    <h3 {...{
      "id": "react-native-userprofile-700"
    }}>{`React Native UserProfile 7.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Updated to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
    </ul>
    <h2 {...{
      "id": "march-4-2025"
    }}>{`March 4, 2025`}</h2>
    <h3 {...{
      "id": "flutter-userprofile-500"
    }}>{`Flutter UserProfile 5.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Update to use BOM `}<a parentName="li" {...{
          "href": "https://central.sonatype.com/artifact/com.adobe.marketing.mobile/sdk-bom"
        }}>{`(Bill of Materials)`}</a>{` for Android SDK dependencies.`}</li>
      <li parentName="ul">{`Update tests to handle the deprecation warning for `}<inlineCode parentName="li">{`setMockMethodCallHandler`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "february-10-2025"
    }}>{`February 10, 2025`}</h2>
    <h3 {...{
      "id": "android-userprofile-301"
    }}>{`Android UserProfile 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h2 {...{
      "id": "june-6-2024"
    }}>{`June 6, 2024`}</h2>
    <h3 {...{
      "id": "react-native-userprofile-602"
    }}>{`React Native UserProfile 6.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Updated typescript files to support strict null checks.`}</li>
    </ul>
    <h2 {...{
      "id": "may-13-2024"
    }}>{`May 13, 2024`}</h2>
    <h3 {...{
      "id": "flutter-userprofile-402"
    }}>{`Flutter UserProfile 4.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Update environment dependencies in pubspec.`}</li>
    </ul>
    <h2 {...{
      "id": "april-24-2024"
    }}>{`April 24, 2024`}</h2>
    <h3 {...{
      "id": "react-native-userprofile-601"
    }}>{`React Native UserProfile 6.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h2 {...{
      "id": "april-23-2024"
    }}>{`April 23, 2024`}</h2>
    <h3 {...{
      "id": "flutter-userprofile-401"
    }}>{`Flutter UserProfile 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added namespace support to the Android module.`}</li>
    </ul>
    <h2 {...{
      "id": "april-16-2024"
    }}>{`April 16, 2024`}</h2>
    <h3 {...{
      "id": "flutter-userprofile-400"
    }}>{`Flutter UserProfile 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk_flutter/tree/main/plugins/flutter_aepuserprofile"
      }}>{`User Profile`}</a>{` for Adobe Experience Platform Flutter plugin compatible with Flutter Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h2 {...{
      "id": "april-12-2024"
    }}>{`April 12, 2024`}</h2>
    <h3 {...{
      "id": "react-native-userprofile-600"
    }}>{`React Native UserProfile 6.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "https://github.com/adobe/aepsdk-react-native/tree/main/packages/userprofile"
      }}>{`User Profile`}</a>{` for Adobe Experience Platform React Native Library compatible with React Native Core 6.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated to use Experience Platform Android `}<inlineCode parentName="li">{`3.x`}</inlineCode>{` SDKs.`}</li>
      <li parentName="ul">{`Updated to use Experience Platform iOS `}<inlineCode parentName="li">{`5.x`}</inlineCode>{` SDKs.`}</li>
    </ul>
    <h2 {...{
      "id": "april-1-2024"
    }}>{`April 1, 2024`}</h2>
    <h3 {...{
      "id": "android-userprofile-300"
    }}>{`Android UserProfile 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`User Profile`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the `}<inlineCode parentName="li">{`MobileCore.registerExtensions()`}</inlineCode>{` API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`UserProfile.updateUserAttribute`}</inlineCode>{` API. Use the `}<inlineCode parentName="li">{`UserProfile.updateUserAttributes`}</inlineCode>{` API instead.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`UserProfile.removeUserAttribute`}</inlineCode>{` API. Use the `}<inlineCode parentName="li">{`UserProfile.removeUserAttributes`}</inlineCode>{` API instead.`}</li>
    </ul>
    <h2 {...{
      "id": "march-20-2024"
    }}>{`March 20, 2024`}</h2>
    <h3 {...{
      "id": "ios-userprofile-500"
    }}>{`iOS UserProfile 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`User Profile`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h2 {...{
      "id": "march-8-2024"
    }}>{`March 8, 2024`}</h2>
    <h3 {...{
      "id": "ios-userprofile-401"
    }}>{`iOS UserProfile 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fix an issue where dependency versions did not have an upper bound restriction.`}</li>
    </ul>
    <h2 {...{
      "id": "july-26-2023"
    }}>{`July 26, 2023`}</h2>
    <h3 {...{
      "id": "android-userprofile-201"
    }}>{`Android UserProfile 2.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Updated POM file with the Apache 2 license.`}</li>
    </ul>
    <h2 {...{
      "id": "jun-5-2023"
    }}>{`Jun 5, 2023`}</h2>
    <h3 {...{
      "id": "ios-userprofile-400"
    }}>{`iOS UserProfile 4.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`User Profile`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 11.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 14.1 with the GitHub release.`}</li>
    </ul>
    <h2 {...{
      "id": "jan-31-2023"
    }}>{`Jan 31, 2023`}</h2>
    <h3 {...{
      "id": "android-userprofile-200"
    }}>{`Android UserProfile 2.0.0`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Major version update for `}<a parentName="p" {...{
            "href": "./index.md"
          }}>{`User Profile`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 2.0.0. This library is now available as an `}<a parentName="p" {...{
            "href": "https://github.com/adobe/aepsdk-userprofile-android"
          }}>{`open source project on GitHub`}</a>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The following APIs have been deprecated and will be removed in a future release:`}</p>
        <table parentName="li">
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Deprecated API`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Recommended Alternative`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><inlineCode parentName="td">{`UserProfile.updateUserAttribute()`}</inlineCode></td>
              <td parentName="tr" {...{
                "align": null
              }}><inlineCode parentName="td">{`UserProfile.updateUserAttributes()`}</inlineCode></td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><inlineCode parentName="td">{`UserProfile.removeUserAttribute()`}</inlineCode></td>
              <td parentName="tr" {...{
                "align": null
              }}><inlineCode parentName="td">{`UserProfile.removeUserAttributes()`}</inlineCode></td>
            </tr>
          </tbody>
        </table>
      </li>
    </ul>
    <h2 {...{
      "id": "jul-2-2021"
    }}>{`Jul 2, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepuserprofile-301"
    }}>{`iOS AEPUserProfile 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a bug preventing proper data migration when presented with an `}<inlineCode parentName="li">{`app group`}</inlineCode>{` .`}</li>
    </ul>
    <h2 {...{
      "id": "feb-5-2021"
    }}>{`Feb 5, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepuserprofile-300"
    }}>{`iOS AEPUserProfile 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Released the brand new Adobe Experience Platform User Profile Swift SDK. It is `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-userprofile-ios"
        }}>{`open sourced on GitHub`}</a>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      